<div class="content">
  <h1>Shopping Cart</h1>
  <a routerLink="/search" aria-label="Continue Shopping">Continue Shopping</a>
  @if (items.length>0) {
  <div class="products">
    <table mat-table [dataSource]="items">
      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>Product</th>
        <td mat-cell *matCellDef="let item">
          <div class="product">
            <img
              [ngSrc]="item|shoppingCartItemImage|fileurl"
              width="100"
              height="125"
              alt="product"
            />
            <div class="info">
              <a
                [routerLink]="['/product',item.product?.no]"
                [queryParams]="{attr_ids:item.product_attr_value_ids,priced_attr_id:item.product_priced_attr_value_id}"
                >{{item.product?.name}}</a
              >
              <div class="attrs">
                @for (attr_value of getItemAttrs(item); track $index) {
                <div class="attr">
                  <span>{{attr_value.attr.name}}:</span>
                  <span>{{attr_value.value.name}}</span>
                </div>
                }
                <div class="attr">
                  <span>{{getItemPricedAttr(item)?.attr?.name}}:</span>
                  <span>{{getItemPricedAttr(item)?.value?.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>Price</th>
        <td mat-cell *matCellDef="let item">
          <app-price [price]="item|shoppingCartItemPrice"></app-price>
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>Quantity</th>
        <td mat-cell *matCellDef="let item">
          <div class="quantity">
            <a (click)="remove(item)">Remove</a>
            <nz-input-number
              [(ngModel)]="item.quantity"
              [nzMin]="1"
              [nzStep]="1"
              [nzPrecision]="0"
              (ngModelChange)="onQuantityChanged(item)"
            />
          </div>
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef class="total">Total</th>
        <td mat-cell *matCellDef="let item">
          <div class="total">
            <app-price [price]="item.amount"></app-price>
            <div class="quantity">
              <a (click)="remove(item)">Remove</a>
              <nz-input-number
                [(ngModel)]="item.quantity"
                [nzMin]="1"
                [nzStep]="1"
                [nzPrecision]="0"
                (ngModelChange)="onQuantityChanged(item)"
              />
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="checkout">
      <div class="line">
        <span class="total">Subtotal</span>
        <span><app-price [price]="subtotal"></app-price></span>
      </div>
      <app-button type="filled" [loading]="loading" (onClick)="checkout()">
        <div class="content">
          <mat-icon fontSet="material-symbols-outlined">security</mat-icon>
          <span> Checkout </span>
        </div></app-button
      >
      <p>Shipping fee will be calculated at checkout</p>
    </div>
  </div>
  }@else{
  <app-shopping-cart-empty></app-shopping-cart-empty>
  }
</div>
